import React from 'react';
import './style.scss';
function Map({onClick, className, show,currentScene}) {
// const [maps,setMaps] = React.useState([EntranceMap,KitchenMap,OfficeMap,BathroomMap])

  return (
    <>
    {/* {show ?
     <img src={mapCross} className={`cross-icon`} onClick={onClick} /> 
    :
    <img src={maps[currentScene]} className='location-icon' onClick={onClick} />
  } */}
    
</>
  );
}

export default Map;
